/* eslint-disable */
export const ENTRY_PORTAL_OPERATIONS_COMPANY = `Concrite`;
export const ENTRY_PORTAL_OPERATIONS_NAME = `Operations Portal`;
export const ENTRY_PORTAL_OPERATIONS_PALETTE_MAIN = `#DA291C`;
